import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import { forwardRef } from 'react';
import { getUuid } from '@front10/helpers/dist/uuid';

import Box from '../Box';
import { StyledProps, CSSProperties } from '@front10';
import Text from '../Text';
import Icon from '../Icon';

export interface Props {
  forwardedRef?: any;
  refInput?: any;
  isChecked?: boolean;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
  onChange?: (e: any) => void;
  label?: string;
  optionStyles?: StyledProps<$TSFixMe>;
  labelStyles?: StyledProps<$TSFixMe>;
  tabIndex?: number;
  name?: string;
  value?: string;
  key?: string;
}

function RadioButton(props: Props) {
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const id = getUuid();
  return (
    <Box display="flex" alignItems="center" className={`${className}`} style={style}>
      <Text className="fr-input-radio-container" {...props.optionStyles}>
        <input
          ref={props.refInput}
          id={`radio-input${id}`}
          className="fr-input-radio"
          type="radio"
          key={props.key}
          name={props.name}
          checked={props.isChecked}
          onChange={props.onChange}
          disabled={props.disabled}
          onBlur={() => {
            if (
              props.forwardedRef !== null &&
              props.forwardedRef !== undefined &&
              props.forwardedRef.current !== undefined &&
              props.forwardedRef.current !== null
            ) {
              props.forwardedRef.current.focus();
            }
          }}
        />
        <Icon icon="radio-button-checked" viewBox="0 0 24 24" size={24} />
        <Icon icon="radio-button-unchecked" viewBox="0 0 24 24" size={24} />
      </Text>
      <Text {...props.labelStyles} textAlign="left" type="label" htmlFor={`radio-input${id}`}>
        {props.label}
      </Text>
    </Box>
  );
}

RadioButton.defaultProps = {
  isChecked: false,
  onChange: () => {}
};

RadioButton.componentName = 'RadioButton';
export default forwardRef((props: StyledProps<Props>, ref: any) => (
  <RadioButton forwardedRef={ref} {...props} />
));
